exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-dot {\n  display: inline-block;\n  width: 10px;\n}", ""]);

// exports
